import { render, staticRenderFns } from "./PatologiasTabela.vue?vue&type=template&id=0236ffa2"
import script from "./PatologiasTabela.vue?vue&type=script&lang=js"
export * from "./PatologiasTabela.vue?vue&type=script&lang=js"
import style0 from "./PatologiasTabela.vue?vue&type=style&index=0&id=0236ffa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports